// extracted by mini-css-extract-plugin
export default {"pdfTool":"FDeFoEMCfPSRoiQiAZq6","selected":"JK6A24VxOZPxg81ZKSGz"};